import { Box, Typography } from '@mui/material'
import { TooltipRenderProps } from 'react-joyride'
import { Button, TextButton } from '~components/web-components'
import { COLORS } from '~theme/colors'

export function CustomTooltip(
  props: TooltipRenderProps & {
    onStartTour?: (id: string, link: string) => void
  },
) {
  const {
    backProps,
    closeProps,
    continuous,
    index,
    primaryProps,
    step,
    tooltipProps,
    size,
    skipProps,
  } = props

  const isLastStep = index + 1 === size
  const showSkipTourButton = skipProps && !isLastStep
  const startTour = step.data?.startTour

  if (step.data?.isLoading) {
    return (
      <Box
        sx={{
          background: COLORS.primary.white,
          borderRadius: '4px',
          width: '320px',
          p: 4,
        }}
        {...tooltipProps}
      >
        {step.content}
      </Box>
    )
  }

  return (
    <Box
      sx={{
        background: COLORS.primary.white,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '4px',
        width: '320px',
      }}
      {...tooltipProps}
    >
      <Box
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 4, lg: 2 },
          height: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 4, lg: 2 },
          }}
        >
          <Typography variant="caption">
            Step {index + 1} of {size}
          </Typography>
          {step.title && <Typography variant="h4">{step.title}</Typography>}
          <div>{step.content}</div>
          {isLastStep &&
            props.onStartTour &&
            typeof startTour?.id === 'string' &&
            typeof startTour?.link === 'string' &&
            typeof startTour?.label === 'string' && (
              <Button
                variant="contained"
                onClick={() =>
                  props.onStartTour?.(startTour.id, startTour.link)
                }
              >
                {startTour.label}
              </Button>
            )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: showSkipTourButton ? 'space-between' : 'end',
            flexWrap: 'wrap',
            mt: 2,
          }}
        >
          {showSkipTourButton && (
            <TextButton {...skipProps}>Skip tour</TextButton>
          )}
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              justifyContent: 'end',
              flexWrap: 'wrap',
            }}
          >
            {index > 0 && <TextButton {...backProps}>Back</TextButton>}
            {continuous && !isLastStep && (
              <Button variant="outlined" {...primaryProps}>
                Next
              </Button>
            )}
            {(!continuous || isLastStep) && (
              <Button {...closeProps}>Close</Button>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
